"use client";

// packages/eden-image/src/index.jsx
import { forwardRef } from "react";
import styled from "styled-components";
import { jsx } from "react/jsx-runtime";
var Img = styled.img`
  max-width: 100%;
  ${({ $focalPoint }) => $focalPoint ? `height: 100%;
         width: 100%;
         object-fit: cover;
         object-position: ${$focalPoint.x} ${$focalPoint.y};
      ` : ""};
`;
var ImageComponent = ({ src, srcSet, sizes, alt, disableLazy, focalPoint, onLoad, ...props }, ref) => /* @__PURE__ */ jsx(
  Img,
  {
    src,
    srcSet,
    sizes,
    alt,
    role: alt ? null : "presentation",
    $focalPoint: focalPoint,
    onLoad,
    loading: disableLazy ? "eager" : "lazy",
    ...props,
    ref
  }
);
var Image = forwardRef(ImageComponent);
Image.displayName = "Image";
export {
  Image
};
